import style from './Peerview.module.scss';

const RatingText = ({ rating }: { rating: string[] }) => {
    return <div className={style.ratingText}>{rating.join('')}</div>;
};

export default RatingText;
